import Image from "next/image"
import Link from "next/link"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "utils"
import { Location2Icon, ParkingIcon, PublicTransportIcon, WazeIcon } from "../icons"
import {
  AddressText,
  BusBadge,
  BusLines,
  InfoBlock,
  InfoLabel,
  InfoRow,
  MobileCard,
  MobileCardBody,
  MobileImageWrapper,
  MobileInfoColumn,
  PortTitle,
  SecondaryText,
  TitleRow,
  WazeButton,
} from "./styled"
import { PortSlideCardProps } from "./types"

const PortSlideCardMobile = ({
  port,
  direction,
  openInWazeLabel,
  publicTransportationLabel,
  parkingLabel,
  isActive,
}: PortSlideCardProps) => {
  const busLines = Array.from(
    new Set((port.busLines || []).map((line) => line.title).filter(Boolean)),
  )
  const hasParkingInfo = Boolean(port.parkingName || port.parkingAddress)
  const hasWazeLink = Boolean(port.wazeLink)

  return (
    <Link href={getNonUmbracoUrl(port.url) || "#"} style={{ textDecoration: "none" }}>
      <MobileCard $direction={direction} $active={isActive}>
        <MobileImageWrapper>
          {port.mapMobileImage && (
            <Image
              src={getUmbracoMediaUrl(port.mapMobileImage)}
              alt={port.portName}
              priority
              fill
              style={{ objectFit: "cover" }}
            />
          )}
        </MobileImageWrapper>
        <MobileCardBody>
          <MobileInfoColumn>
            <TitleRow>
              <Location2Icon />
              <PortTitle>{port.portName}</PortTitle>
            </TitleRow>

            {port.address && <AddressText>{port.address}</AddressText>}

            {busLines.length > 0 && (
              <InfoBlock>
                <InfoRow>
                  <PublicTransportIcon />
                  <InfoLabel>{publicTransportationLabel}</InfoLabel>
                </InfoRow>
                <BusLines>
                  {busLines.map((line) => (
                    <BusBadge key={line}>{line}</BusBadge>
                  ))}
                </BusLines>
              </InfoBlock>
            )}

            {hasParkingInfo && (
              <InfoBlock>
                <InfoRow>
                  <ParkingIcon />
                  <InfoLabel>{port.parkingName || parkingLabel}</InfoLabel>
                </InfoRow>
                {port.parkingAddress && <SecondaryText>{port.parkingAddress}</SecondaryText>}
              </InfoBlock>
            )}
          </MobileInfoColumn>
          {hasWazeLink ? (
            <WazeButton
              href={getNonUmbracoUrl(port.wazeLink)}
              target="_blank"
              rel="noreferrer"
              aria-label={`${openInWazeLabel} - ${port.portName}`}
              onClick={(e) => e.stopPropagation()}
            >
              <WazeIcon />
            </WazeButton>
          ) : (
            <WazeButton
              href="#"
              aria-label={`${openInWazeLabel} - ${port.portName}`}
              $isDisabled
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              <WazeIcon />
            </WazeButton>
          )}
        </MobileCardBody>
      </MobileCard>
    </Link>
  )
}

export default PortSlideCardMobile
